/**
 * 実行時の設定（03 1.3・FE-D-018）：起動時に 1 回だけ /app-config.json を読む。秘密の値は置かない。
 * 読めなければ呼び出し側が INTERNAL_ERROR の文言を全画面に出す（予備の設定には切り替えない）。
 */
export type AppEnvName = 'dev' | 'mai' | 'prd' | 'local';

export interface RuntimeAppConfig {
  app_env: AppEnvName;
  app_base_url: string;
}

const APP_ENV_NAMES: readonly string[] = ['dev', 'mai', 'prd', 'local'];

let cached_config: Promise<RuntimeAppConfig> | null = null;

function parseConfig(value: unknown): RuntimeAppConfig {
  if (typeof value !== 'object' || value === null) {
    throw new Error('app-config.json の形が正しくありません');
  }
  const record = value as Record<string, unknown>;
  const app_env = record.app_env;
  if (typeof app_env !== 'string' || !APP_ENV_NAMES.includes(app_env)) {
    throw new Error('app-config.json の app_env が正しくありません');
  }
  return {
    app_env: app_env as AppEnvName,
    app_base_url: typeof record.app_base_url === 'string' ? record.app_base_url : window.location.origin,
  };
}

/** 1 回だけ読む（2 回目以降は同じ結果を返す） */
export function loadRuntimeConfig(fetcher: typeof fetch = fetch): Promise<RuntimeAppConfig> {
  cached_config ??= (async () => {
    const response = await fetcher(new URL('/app-config.json', window.location.origin), { cache: 'no-cache' });
    if (!response.ok) {
      throw new Error(`app-config.json を読めません（${response.status}）`);
    }
    return parseConfig(await response.json());
  })().catch((error: unknown) => {
    cached_config = null;
    throw error;
  });
  return cached_config;
}

/** テストだけで使う */
export function resetRuntimeConfigForTest(): void {
  cached_config = null;
}
